module.exports = __webpack_public_path__ + "static/iso-91a126a81ce88133dba1b2ec64033c49.png";